import { concat, hash } from '@ember/helper';
import { service } from '@ember/service';

import CpPanel from 'ember-collapsible-panel/components/cp-panel/component';
import { t } from 'ember-intl';
import svgJar from 'ember-svg-jar/helpers/svg-jar';
import { or } from 'ember-truth-helpers';

import Component from 'umg-ember-backend/components/record-detail/forms';
import Form from 'umg-ember-backend/components/ui/form';

export default class RecordDetailFormsProductTrackComponent extends Component {
  // Services
  @service data;

  // Template
  <template>
    <Form @model={{@model}} @showErrors={{@showErrors}} as |form|>
      <div class='o-layout'>
        <div class='o-layout__item u-1/1 u-1/2@tablet'>
          <form.fieldset @titleKey='general' as |fieldset|>
            <fieldset.field @property='name' />
            <fieldset.field @property='duration' @type='number' />
            <fieldset.field @property='ghosttrack' @type='checkbox' />
            <fieldset.field @property='isrc' />
            <fieldset.field @property='linkedStereoIsrc' />
            <fieldset.field @property='lyrics' @type='textarea' />
            <fieldset.field @property='mp3Custom' />
            <fieldset.field @disabled={{true}} @property='mp3Itunes' />
            <fieldset.field @property='mp3' />
            <fieldset.field @property='recordingId' @type='number' />
            <fieldset.field @property='soundFlag' @type='checkbox' />
            <fieldset.field @property='versionName' />
          </form.fieldset>
        </div>
        <div class='o-layout__item u-1/1 u-1/2@tablet'>
          <form.fieldset @titleKey='assignments' as |fieldset|>
            <fieldset.field
              @property='contributors'
              @type='has-many-join'
              @hasManyForeignModelName='artist'
              @on={{hash openNewRecord=false removeRecord=this.deleteRelation}}
              as |contributor field|
            >
              <CpPanel @open={{contributor.isNew}} as |panel|>
                <panel.toggle>
                  {{svgJar
                    (if contributor.mainContributor 'star' 'star-outline')
                    class='u-icon'
                  }}
                  {{contributor.artist.displayLabel}}
                  {{#if contributor.category}}
                    -
                    {{contributor.category.name}}
                  {{/if}}
                </panel.toggle>
                <panel.body>
                  <Form @model={{contributor}} as |subform|>
                    <subform.field
                      @property='category'
                      @type='select-record'
                      @isSearchEnabled={{true}}
                      @options={{this.data.contributorCategories}}
                      @disabled={{field.isDisabled}}
                    />
                    <subform.field
                      @property='mainContributor'
                      @type='checkbox'
                    />
                  </Form>
                </panel.body>
              </CpPanel>
            </fieldset.field>

            <fieldset.field
              @property='productWorks'
              @type='has-many'
              @on={{hash openNewRecord=false}}
            />
          </form.fieldset>

          {{#if (or @model.additionalTrackData @model.additionalContributors)}}
            <form.fieldset @titleKey='additionalTrackInfo' @isVisible={{true}}>
              {{#if @model.additionalContributors}}
                <div class='c-ui-form-field'>
                  <label class='c-ui-form-field__label'>
                    {{t 'forms.product-track.fields.additionalContributors'}}
                  </label>
                  {{#each @model.additionalContributors as |contributor|}}
                    {{contributor.firstName}}
                    {{contributor.lastName}}
                    -
                    {{contributor.function}}<br />
                  {{/each}}
                </div>
              {{/if}}

              {{#if @model.additionalTrackData}}
                {{#each-in @model.additionalTrackData as |key value|}}
                  <div class='c-ui-form-field'>
                    <label class='c-ui-form-field__label'>
                      {{t (concat 'forms.product-track.fields.' key)}}
                    </label>
                    {{if value value '-'}}
                  </div>
                {{/each-in}}
              {{/if}}
            </form.fieldset>
          {{/if}}

          <form.sections.meta />
        </div>
      </div>
    </Form>
  </template>
}
